<template>
  <div>
    <div class="bodyCont">
      <div class="contLeft">
        <div class="cont">
          <div class="box" v-for="(item, index) in typeList" @click="typeClick(index)">
            <div :class="index == typeOn ? 'shu' : 'shu1'"></div>
            <div class="name" :class="index == typeOn ? 'on' : ''">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="contRit">
        <div v-if="typeOn == 0">
          <Zhiwei />
        </div>
        <div v-if="typeOn == 1">
          <linggong />
        </div>
        <div v-if="typeOn == 2">
          <PeoLing />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PeoLing from '../linggong/peoLing.vue';
import linggong from '../linggong/linggong.vue';
import Zhiwei from './zhiwei.vue';

export default {
  components: {
    Zhiwei,
    PeoLing,
    linggong,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: [
        {
          name: "职位招聘",
        },
        {
          name: "零工岗位",
        },
        {
          name: "零工师傅",
        },
      ],
    };
  },
  created() { },
  activated() {
    
  },
  methods: {
    typeClick(i) {
      this.typeOn = i;
    },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
.bodyCont {
  display: flex;
}

.contLeft {
  width: 250px;
  box-sizing: border-box;
  padding-right: 20px;
  padding-top: 15px;

  .cont {
    width: 100%;
    height: 500px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px 0;

    .box {
      height: 45px;
      display: flex;
      align-items: center;
      padding-left: 15px;
      cursor: pointer;

      .shu {
        width: 5px;
        height: 18px;
        border-radius: 5px;
        background-color: #147ee0;
        margin-right: 8px;
      }

      .shu1 {
        width: 5px;
        height: 18px;
        border-radius: 5px;
        margin-right: 8px;
      }

      .name {
        font-size: 16px;
        color: #666;
      }

      .on {
        font-weight: 600;
        color: #000;
      }
    }
  }
}

.contRit {
  width: calc(100% - 250px);
}
</style>
